export default function printVoucher(type, q, startDate, endDate) {
  const token = localStorage.getItem("token");
  printVoucherPerType(token, type, q, startDate, endDate)
}

function printVoucherPerType(token, type, q, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/voucher/print/report/find/all/?auth=${token}&type=${type}&q=${q}&startDate=${startDate}&endDate=${endDate}`
  );
}
